import { useState, useEffect } from 'react';
import logo from '../../assets/banner/home/logo.png';
import icon_home from '../../assets/banner/home/icon_home.svg';
import { useTranslation } from 'react-i18next';
export const menuItems = [
    { href: 'gioi-thieu', label: 'menu.about' },
    // { href: 'dich-vu', label: 'menu.services' },
    { href: 'kien-thuc', label: 'menu.knowledge' },
    { href: 'tin-tuc', label: 'menu.news' },
    // { href: '#tuyen-dung', label: 'menu.careers' },
    // { href: 'lien-he', label: 'menu.contact' }
];
const Header = () => {
    const defaultLanguage = localStorage.getItem('language') || 'vi';
    const [language, setLanguage] = useState(defaultLanguage);
    const { t, i18n } = useTranslation();
    const [activePath, setActivePath] = useState('/');
    useEffect(() => {
        i18n.changeLanguage(defaultLanguage);
        const hash = window.location.hash || '/';
        setActivePath(hash);
    }, []);

    const toggleLanguage = (str: string) => {
        const newLang = str;
        setLanguage(newLang);
        localStorage.setItem('language', newLang);
        i18n.changeLanguage(newLang);
    };

    return (
        <div>
            <header className='header'>
                <div className='logo'>
                    <img 
                        src={logo} 
                        alt='DolphinEx'
                        onError={(e) => {
                            console.error('Logo failed to load:', logo);
                            e.currentTarget.style.display = 'none';
                        }} />
                </div>
                <nav>
                    {
                        <img
                            className='cursor-pointer'
                            onClick={() => setActivePath('/')}
                            src={icon_home} alt='home' />
                    }
                    {menuItems.map((item, index) => (
                        <a
                            key={index}
                            href={item.href}
                            className={activePath === item.href ? 'active' : ''}
                            onClick={() => setActivePath(item.href)}
                        >
                            {t(item.label)}
                        </a>
                    ))}
                </nav>
                <div className='language-switcher font-tomorrow'>
                    <a className={language === 'vi' ? 'active' : ''} onClick={() => toggleLanguage('vi')} href='#lien-he'>VI</a>
                    <a className={language === 'en' ? 'active' : ''} onClick={() => toggleLanguage('en')} href='#lien-he'>EN</a>
                </div>
            </header>
        </div>
    )
}

export default Header;